import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, Clock3, Users } from 'lucide-react';
import { hasPermission } from '../utils/permissions';

const MyTimeHub = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1 style={{ color: '#1e293b', marginBottom: '20px' }}>My Time</h1>
      <p style={{ color: '#64748b', marginBottom: '40px' }}>Track what happened across the app in one place.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {hasPermission('canTimeTracking') && (
          <div
            onClick={() => navigate('/my-time/time-tracking')}
            style={cardStyle}
            className="hover-card"
          >
            <div style={{ ...iconBoxStyle, backgroundColor: '#e0f2fe' }}>
              <Clock3 size={32} color="#0369a1" />
            </div>
            <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Time Tracking</h3>
            <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
              Log your work start, end, break, and notes for each workday.
            </p>
          </div>
        )}

        {hasPermission('canTimeTrackingOverview') && (
          <div
            onClick={() => navigate('/my-time/time-tracking/all')}
            style={cardStyle}
            className="hover-card"
          >
            <div style={{ ...iconBoxStyle, backgroundColor: '#dcfce7' }}>
              <Users size={32} color="#15803d" />
            </div>
            <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Time Tracking Overview</h3>
            <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
              View all submitted time entries across your employees.
            </p>
          </div>
        )}

        <div
          onClick={() => navigate('/my-time/activity-log')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{ ...iconBoxStyle, backgroundColor: '#ecfccb' }}>
            <Activity size={32} color="#4d7c0f" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Activity Log</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            View a combined timeline of updates, new entries, imports, and system activity across the application.
          </p>
        </div>
      </div>
    </div>
  );
};

const cardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', cursor: 'pointer', transition: 'all 0.2s ease', border: '1px solid #e2e8f0', height: '100%', boxSizing: 'border-box' };
const iconBoxStyle = { width: '56px', height: '56px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' };

export default MyTimeHub;